import styled from 'styled-components/macro'

export const RadioButtonContainer = styled.div`
  display: flex;
  align-items: center; /* Align items vertically */
  justify-content: center; /* Align items vertically */
  margin-bottom: 12px;
  margin-left: 15px;
  transition: all 0.3s ease-in-out;
  color: rgba(0, 0, 0, 0.46);
  font-weight: 400;
  &.selected {
    font-weight: 700;
    font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
    color: #000000;
  }
`

export const Label = styled.label`
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5; /* Adjust line height for better spacing */
  letter-spacing: -0.075em;
  margin-right: 8px;
  margin-left: 8px;
`

export const Input = styled.input`
  appearance: none;
  margin: 0;
  width: 16px;
  height: 16px;
  border: 2px solid black;
  border-radius: 50%;
  transition: all 0.1s ease-in-out;
  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    margin: 2px;
  }
  &:checked::after {
    background-color: black;
  }
  cursor: pointer;
`
